module.exports = __webpack_public_path__ + "static/media/reference_image.7816f77c.svg";